import React from "react";

export default function TemplatePayslip({ props }) {
  return (
    <div>
      <table
        style={{
          borderWidth: 1,
          borderColor: "#ffffff",
          borderCollapse: "collapse",
          height: 26,
          alignItems: "right",
          width: "100%",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                width: "100%",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#ffffff",
                alignItems: "right",
              }}
            >
              <p
                style={{
                  fontSize: 12,
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "8.5pt",
                    fontWeight: "bold",
                    fontStyle: "italic",
                  }}
                >
                  {props.SalaryTitle}
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{
          borderCollapse: "collapse",
          marginLeft: "9.3pt",
          alignItems: "center",
        }}
      >
        <tbody>
          <tr style={{ height: "14.1pt" }}>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "75.45pt",
                borderWidth: "1.5pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "4pt 0pt 0pt 4pt" }}>
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  Họ và tên
                </span>
              </p>
            </td>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "113.35pt",
                borderWidth: "1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "4pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.FullName}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "4pt 0pt 0pt 4pt" }}>
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  Mã bộ phận
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "113.2pt",
                borderWidth: "1.5pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "4pt 0pt 0pt 2pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.DepartmentCode}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "14.75pt" }}>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "75.45pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 4pt" }}>
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  Mã nhân viên
                </span>
              </p>
            </td>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "113.35pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.EmployeeCode}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 4pt" }}>
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  Chức danh
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "113.2pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 2pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.PositionName}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "14.75pt" }}>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "75.45pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 4pt" }}>
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  Ngày vào công ty
                </span>
              </p>
            </td>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "113.35pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.DateIn}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderTop: "1pt solid #000000",
                borderRight: "none",
                borderBottom: "1pt solid #000000",
                borderLeft: "1pt solid #000000",
              }}
            >
              <p
                style={{
                  fontSize: "7pt",
                  fontWeight: "bold",
                  textAlign: "left",
                  margin: "3pt 0pt 0pt 4pt",
                }}
              >
                <span style={{ fontFamily: "Arial" }}>Ngày </span>
                <span style={{ fontFamily: '"Microsoft Sans Serif"' }}>
                  lương
                </span>
                <span style={{ fontFamily: "Arial" }}> tiêu chuẩn</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "113.2pt",
                borderTop: "1pt solid #000000",
                borderRight: "1.5pt solid #000000",
                borderBottom: "1pt solid #000000",
                borderLeft: "none",
              }}
            >
              <p style={{ margin: "1pt 4pt 0pt 0pt", textAlign: "right" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.StandardWorkingDay}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "14.75pt" }}>
            <td
              colSpan={5}
              valign="top"
              style={{
                width: "188.8pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "3pt 0pt 0pt 5pt",
                }}
              >
                <span style={{ fontFamily: '"Microsoft Sans Serif"' }}>
                  Lương
                </span>
                <span style={{ fontFamily: '"Microsoft Sans Serif"' }}> </span>
                <span style={{ fontFamily: '"Microsoft Sans Serif"' }}>cơ</span>
                <span style={{ fontFamily: '"Microsoft Sans Serif"' }}>
                  {" "}
                  bản
                </span>
                <span style={{ fontFamily: '"Times New Roman"' }}> </span>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    margin: "3pt 0pt 0pt 100pt",
                  }}
                >
                  {props.BasicSalary}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 4pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Tổng số tiền làm thêm
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "113.2pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "3pt 4pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OverTimeAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "14.75pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "2pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Số ngày làm trong tháng
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "4pt 3pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.FixWorkingDays}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "2pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hệ số 150 %
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "1pt 4pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTWorkingDayHours}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  textAlign: "right",
                  margin: "2pt 4pt 0pt 0pt",
                }}
              >
                <span style={{ fontSize: "7pt" }}></span>
                <span style={{ fontSize: "11pt" }}> </span>
                <span style={{ fontSize: "7pt" }}>
                  {props.OTWorkingDayAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "14.75pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Số ngày làm thực tế
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-41pt",
                  margin: "4pt 4pt 0pt 41pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ActualWorkingDays}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hệ số 210%
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "3pt 4pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTWorkingDayNightHours}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "3pt 3pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTWorkingDayNightAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "23.15pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "3pt 18pt 0pt 5pt",
                  lineHeight: "1.16667",
                }}
              >
                <span>Lương theo ngày công (đã bao gồm phụ cấp lương)</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  margin: "3pt 4pt 0pt 24pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.BasicAmount}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hệ số 200%
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "3pt 4pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTWeeklyHolidayDayHours}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "3pt 4pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTWeeklyHolidayDayAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "12.55pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "2pt 0pt 0pt 5pt",
                }}
              >
                <span>Tiền </span>
                <span>lương</span>
                <span> </span>
                <span>đóng</span>
                <span> BHXH</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-30pt",
                  margin: "4pt 4pt 0pt 30pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.BasicSalaryInsurance}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "22.95pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "3pt 17pt 0pt 5pt",
                  lineHeight: 1,
                }}
              >
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  Tổng các loại trợ cấp, bổ sung khác
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-30pt",
                  margin: "4pt 4pt 0pt 30pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  {props.TotalAllowance}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "5pt 0pt 0pt 5pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hệ số 270%
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "5pt 4pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTWeeklyHolidayNightHours}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "5pt 3pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTWeeklyHolidayNightAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "10.35pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                }}
              >
                <span>Phụ cấp bậc </span>
                <span>lương</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-4pt",
                  margin: "1pt 4pt 0pt 36pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL19}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "13.75pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 3pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Phụ cấp tiếng nhật
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ margin: "3pt 4pt 0pt 30pt", textAlign: "right" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL05}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "3pt 0pt 0pt 7pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hệ số 300%
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "3pt 4pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTPublicHolidayDayHours}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "3pt 3pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTPublicHolidayDayAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.25pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span>Phụ cấp kĩ </span>
                <span>năng</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-4pt",
                  margin: "1pt 4pt 0pt 36pt",
                  lineHeight: "7.65pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL04}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hệ số 390%
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTPublicHolidayNightHours}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.OTPublicHolidayNightAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.5pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.5pt",
                }}
              >
                <span>Phụ cấp kế toán </span>
                <span>trư</span>
                <span>ởng</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.5pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL12}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.35pt",
                }}
              >
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  Tổng các loại khấu trừ
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "113.2pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  textIndent: "-29pt",
                  margin: "1pt 4pt 0pt 44pt",
                  lineHeight: "7.4pt",
                }}
              >
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "7pt",
                    fontWeight: "bold",
                  }}
                >
                  {props.TotalDeduction}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.25pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.4pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Phụ cấp thâm niên
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-4pt",
                  margin: "1pt 4pt 0pt 36pt",
                  lineHeight: "7.4pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL11}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.4pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Bảo hiểm xã hội
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 9pt",
                  lineHeight: "7.4pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  8%
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.4pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.SocialInsuaranceAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.5pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.9pt",
                }}
              >
                <span>Thư</span>
                <span>ởng chuyên cần</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-4pt",
                  margin: "1pt 4pt 0pt 36pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL02}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.9pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Bảo hiểm y tế
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.9pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  1.5%
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.4pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.HealthInsuaranceAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "10.25pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                }}
              >
                <span>Hổ trợ </span>
                <span>đi</span>
                <span> lại</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-4pt",
                  margin: "1pt 4pt 0pt 36pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL07}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "1pt 0pt 0pt 7pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Bảo hiểm thất nghiệp
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "1pt 3pt 0pt 9pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  1%
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "1pt 4pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.UnemploymentInsuranceAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.25pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hổ trợ nhà ở
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textIndent: "-4pt",
                  margin: "1pt 4pt 0pt 36pt",
                  lineHeight: "7.65pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL06}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span>Phí công </span>
                <span>đoàn</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.UnionFee}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.75pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hổ trợ ca 2
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL17}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Thuế thu nhập cá nhân
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.PITAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.25pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.15pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hổ trợ ca 3
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.15pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL18}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.15pt",
                }}
              >
                <span>Tiền </span>
                <span>đi</span>
                <span> muộn, về sớm</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt",
                  lineHeight: "7.15pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.InLateOutEarlyHours}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.15pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.InLateOutEarlyAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "10pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "1pt 0pt 0pt 3pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Hỗ trợ con nhỏ
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "1pt 4pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL20}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "10pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.9pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Tiền sinh nhật
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "1pt 4pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL10}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.75pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span>Tiền </span>
                <span>thư</span>
                <span>ởng</span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL14}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span>Các loại khác ( </span>
                <span>trư</span>
                <span>ớc thuế)</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.NontaxableDeduction}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.75pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Tiền cải tiến
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL15}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Các loại khác ( sau thuế)
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.TaxableDeduction}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.75pt" }}>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "124.95pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Thu nhập khác (nếu có)
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.ALL01}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span>Số ngày nghỉ trừ</span>
                <span> lương</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "2pt 4pt 0pt",
                  lineHeight: "6.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.TotalLeaveUnHour}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.TotalLeaveUnAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.75pt" }}>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "75.45pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Số ngày làm ca HC
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "49.5pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  margin: "1pt 7pt 0pt 6pt",
                  lineHeight: "7.65pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.NumHC}
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span>Số ngày nghỉ phép, </span>
                <span>đ</span>
                <span>ặc biệt</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.TotalLeaveHours}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ margin: "1pt 4pt 0pt", textAlign: "right" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.TotalLeaveAmount}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.75pt" }}>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "75.45pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Số ngày làm ca 1
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "49.5pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  margin: "1pt 7pt 0pt 2pt",
                  lineHeight: "7.65pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.NumC1}
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Số ngày phép còn lại
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.AnnualDayRemaining}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.AnnualPaymentRemaining}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "9.75pt" }}>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "75.45pt",
                borderWidth: "1pt 1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 3pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Số ngày làm ca 2
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "49.5pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  margin: "1pt 7pt 0pt 2pt",
                  lineHeight: "7.65pt",
                  textAlign: "right",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.NumC2}
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "6pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  fontFamily: '"Microsoft Sans Serif"',
                  fontSize: "7pt",
                  textAlign: "left",
                  margin: "1pt 0pt 0pt 7pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span>Số ngày nghỉ lễ </span>
                <span>hư</span>
                <span>ở</span>
                <span>ng lương</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 4pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.NumOfPaidHolidays}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "1pt 5pt 0pt 0pt",
                  lineHeight: "7.65pt",
                }}
              >
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.AmmountOfPaidHolidays}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "13.1pt" }}>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "75.45pt",
                borderWidth: "1pt 1pt 1.5pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "1pt 0pt 0pt 3pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  Số ngày làm ca 3
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "49.5pt",
                borderWidth: "1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ margin: "1pt 7pt 0pt 2pt", textAlign: "right" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                    textAlign: "right",
                  }}
                >
                  {props.NumC3}
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              valign="top"
              style={{
                width: "63.85pt",
                borderWidth: "1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "right", margin: "1pt 4pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: '"Microsoft Sans Serif"',
                    fontSize: "7pt",
                  }}
                >
                  {props.NightShiftAmount}
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "80.15pt",
                borderWidth: "1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "60.9pt",
                borderWidth: "1pt 1pt 1.5pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "52.3pt",
                borderWidth: "1pt 1.5pt 1.5pt 1pt",
                borderStyle: "solid",
                borderColor: "#000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "15pt" }}>
            <td
              valign="top"
              style={{
                width: "51.7pt",
                borderTop: "1.5pt solid #000000",
                borderRight: "none",
                borderBottom: "1.5pt solid #000000",
                borderLeft: "1.5pt solid #000000",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "96.6pt",
                borderTop: "1.5pt solid #000000",
                borderRight: "none",
                borderBottom: "1.5pt solid #000000",
                borderLeft: "none",
              }}
            >
              <p
                style={{
                  fontSize: "8.5pt",
                  fontWeight: "bold",
                  textAlign: "left",
                  margin: "2pt 0pt 0pt 2pt",
                }}
              >
                <span style={{ fontFamily: "Arial" }}>Tổng </span>
                <span style={{ fontFamily: '"Microsoft Sans Serif"' }}>
                  lương
                </span>
                <span style={{ fontFamily: "Arial" }}> thực nhận</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                width: "40.5pt",
                borderTop: "1.5pt solid #000000",
                borderRight: "none",
                borderBottom: "1.5pt solid #000000",
                borderLeft: "none",
              }}
            >
              <p style={{ textAlign: "left", margin: "0pt" }}>
                <span
                  style={{ fontFamily: '"Times New Roman"', fontSize: "7pt" }}
                >
                  &nbsp;
                </span>
              </p>
            </td>
            <td
              colSpan={3}
              valign="top"
              style={{
                width: "193.35pt",
                borderTop: "1.5pt solid #000000",
                borderRight: "1.5pt solid #000000",
                borderBottom: "1.5pt solid #000000",
                borderLeft: "none",
              }}
            >
              <p style={{ textAlign: "right", margin: "2pt 4pt 0pt 0pt" }}>
                <span
                  style={{
                    fontFamily: "Arial",
                    fontSize: "8.5pt",
                    fontWeight: "bold",
                  }}
                >
                  {props.FinalNetIncome}
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
